export default "__VITE_ASSET__B$E4rb$l__"